import { DELIVERY_ROUTE_STOP_LIMIT } from './delivery-route-constants'

export function getDeliveryRouteSelectionCount(...selectionGroups) {
  return new Set(
    selectionGroups
      .flatMap((selectionGroup) => Array.from(selectionGroup ?? []))
      .filter((selectionId) => selectionId !== null && selectionId !== undefined)
      .map(String)
  ).size
}

export function applyDeliveryRouteSelectionActions({
  actions = [],
  lockedOrderIds = [],
  reservedStopCount = 0,
  selectedOrderIds = [],
  stopLimit = DELIVERY_ROUTE_STOP_LIMIT,
}) {
  const lockedOrderIdSet = new Set(lockedOrderIds)
  const nextOrderIds = new Set(selectedOrderIds)

  actions
    .filter(({ checked, orderId }) => !checked && !lockedOrderIdSet.has(orderId))
    .forEach(({ orderId }) => nextOrderIds.delete(orderId))

  let stopLimitReached = false

  actions
    .filter(({ checked, orderId }) => checked && !lockedOrderIdSet.has(orderId))
    .forEach(({ orderId }) => {
      if (nextOrderIds.has(orderId)) return

      if (
        getDeliveryRouteSelectionCount(nextOrderIds, lockedOrderIdSet) + reservedStopCount >=
        stopLimit
      ) {
        stopLimitReached = true
        return
      }

      nextOrderIds.add(orderId)
    })

  return {
    selectedOrderIds: Array.from(nextOrderIds),
    stopLimitReached,
  }
}
